import { z } from 'zod';
import { isoDateTimeSchema } from '../../common.js';
/**
 * Per-member calendar preferences (Dan, 2026-10-13). Lives in the `household` doc beside
 * `digestPrefs`, **not** in per-device localStorage like the week-start preference: where a
 * new event lands is a privacy default, so it has to follow the person to every device and
 * to the server-side writers (the MCP connector) — a phone that forgot the setting would
 * quietly publish an event to the whole family.
 */
/** Key of the `Y.Map<memberId, CalendarPref>` inside the `household` doc. */
export const HOUSEHOLD_CALENDAR_PREFS_KEY = 'calendarPrefs';
/**
 * Where a member's new events start out: `family` = the shared calendar, `private` = their
 * personal doc ("Just me", WS-15). Only a starting point — the event form's audience picker
 * still changes it per event.
 */
export const newEventPlacementSchema = z.enum(['family', 'private']);
/** The household default, and the fallback for a missing or malformed preference. */
export const DEFAULT_NEW_EVENT_PLACEMENT = 'family';
export const calendarPrefSchema = z.object({
    newEvents: newEventPlacementSchema,
    updatedAt: isoDateTimeSchema,
});
/** Parses a value out of the Yjs map; malformed/old entries fall back to the default. */
export function parseCalendarPref(value) {
    const parsed = calendarPrefSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
}
/** The effective starting placement for a member with no (or an invalid) stored preference. */
export function newEventPlacementFor(pref) {
    return pref?.newEvents ?? DEFAULT_NEW_EVENT_PLACEMENT;
}
//# sourceMappingURL=prefs.js.map